const puzzle = {
  id: "mZuzEEVqHeBgdC",
  name: "Cryptograms",
  rebuses: [
    {
      id: "8a0328a8-163c-411e-ae44-e4123eb6",
      clues: [
        {
          id: "0cdcabe3-7b-f34234df827",
          clueValues: [
            {
              id: "4a85fc08-08cb-4177-aa83-c8e65651738fed",
              value: "HelenKellerCryptogram",
              type: "customComponent",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "I J T = T H E",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "815dbdb7-01a5-446a-b599-574d83926169",
            value: "Hellen Keller",
          },
          {
            id: "815dbdb7-jnz-446a-b599-574d83926169",
            value: "Helen Keller",
          },
          {
            id: "23-jnz-446a-b599-574d83926169",
            value: "Helen Keler",
          },
        ],
        solvedText: "Helen Keller",
      },
    },
    {
      id: "8a01229a8-163c-411e-ae44-e4123eb6",
      clues: [
        {
          id: "012cabe3-7b-f34234df827",
          clueValues: [
            {
              id: "4a81208-08cb-4177-aa83-c8e65612fed",
              value: "GandhiCryptogram",
              type: "customComponent",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "W B P = T H E",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "815543db7-01a5-446a-b599-574d83926169",
            value: "Gandhi",
          },
          {
            id: "81516b7-01a5-446a-b599-574d83926169",
            value: "Mahatma Gandhi",
          },
        ],
        solvedText: "Mahatma Gandhi",
      },
    },
    {
      id: "8a0198-163c-4121fc1e-ae44-e4123eb6",
      clues: [
        {
          id: "nhrt564-7b-f34234df827",
          clueValues: [
            {
              id: "4a81508-08cb-4177-aa83-8764",
              value: "ForrestGumpCryptogram",
              type: "customComponent",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "E T B = Y O U",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "815653db7-01a5-446a-b599-574d8126169",
            value: "Gump",
          },
          {
            id: "81516b7-01a5-446a-b599-574d8169",
            value: "Forrest Gump",
          },
          {
            id: "81516b7-01a5-446a-b599-574d169",
            value: "Forrest",
          },
          {
            id: "811gf6b7-01a5-446a-b599-574d169",
            value: "Forest Gump",
          },
          {
            id: "811gf6b7-01a5-897ccd-b599-574d169",
            value: "Forest",
          },
        ],
        solvedText: "Forrest Gump",
      },
    },
    {
      id: "8a0198-163c-4121fc1e-ae44-n5612",
      isUnlocked: true,
      clues: [
        {
          id: "nhrt564-7b-f34234df827",
          clueValues: [
            {
              id: "2749-08cb-4177-aa83-8764",
              value: "ShakespeareCryptogram",
              type: "customComponent",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "N F K = T H E",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "bf91632c5-4332-32-aee1-1cee4c9dgfh68",
            value: "William Shakespeare",
          },
          {
            id: "a7b1c8f8f-5daf-4b72-b-02b5acb6bc1",
            value: "Shakespeare",
          },
        ],
        solvedText: "William Shakespeare",
      },
    },
  ],
};
export default puzzle;
